import { theme } from '@fiverr-private/theme';
import { brandPageTheme } from '../../shared/constants';

export const PROS_POINTS_COUNT = 4;

export const PRO_SECTION_TEXT_AND_CTA_URLS = [
    {
        descriptionHeading: 'Website development experts',
        descriptionText:
            'Our top-tier developers are handpicked for their talent, precision, and ability to bring smart ideas to life. From snappy sites to powerhouse platforms, we’ve got the tech minds to match your vision. Ready?',
        ctaUrl: 'https://pro.fiverr.com/categories/programming-tech/website-development?source=category_tree&expert_listings=true',
    },
    {
        descriptionHeading: 'Software development experts',
        descriptionText:
            'Our engineers are builders of the future—fluent in code, fluent in vision. From robust systems to custom solutions, we develop with precision, scalability, and purpose. Complex challenges? That’s their comfort zone.',
        ctaUrl: 'https://pro.fiverr.com/categories/programming-tech/software-development?source=category_tree&expert_listings=true',
    },
    {
        descriptionHeading: 'Social media marketing experts',
        descriptionText:
            'Our elite strategists know how to turn scrolls into stops—and followers into fans. From bold brand storytelling to data-driven campaigns, we craft presence with purpose. Let’s make your message magnetic.',
        ctaUrl: 'https://pro.fiverr.com/categories/online-marketing/social-marketing?source=category_tree&expert_listings=true',
    },
    {
        descriptionHeading: 'SEO experts',
        descriptionText:
            'Our SEO experts don’t chase trends—they set them. With a sharp eye for search intent and a toolkit built for performance, we optimize every click, crawl, and conversion. Let’s get you found—by the right people.',
        ctaUrl: 'https://pro.fiverr.com/categories/online-marketing/seo-services?source=category_tree&expert_listings=true',
    },
    {
        descriptionHeading: 'Architecture & interior design experts',
        descriptionText:
            'From structure to finish, our architects and designers shape environments that feel as good as they look. Sophisticated, intentional, and always tailored—we bring your space to life with vision and care.',
        ctaUrl: 'https://pro.fiverr.com/categories/graphics-design/architectural-design-services?source=category_tree&expert_listings=true',
    },
];
export const PRO_SECTION_SELLERS = [
    {
        src: 'b5101d497d622d421154e932ceaa7927-1751867297260/ProSeller-1-v2560-cropped-2x.jpg',
        alt: 'Pro Section Item 1',
        domain: 'Website development',
        domainDesktop: 'Website developer',
        ctaUrl: PRO_SECTION_TEXT_AND_CTA_URLS[0].ctaUrl,
        name: 'Danny Lee',
        avatarSrc:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/778bcdb703d1be930088d803f5422479-1751956158376/avatar-pro-seller-1-2x.jpg',
    },
    {
        src: 'b5101d497d622d421154e932ceaa7927-1751867297255/ProSeller-2-v2560-cropped-2x.jpg',
        alt: 'Pro Section Item 2',
        domain: 'Software development',
        domainDesktop: 'Software developer',
        ctaUrl: PRO_SECTION_TEXT_AND_CTA_URLS[1].ctaUrl,
        name: 'Jonah Smith',
        avatarSrc:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/778bcdb703d1be930088d803f5422479-1751956158385/avatar-pro-seller-2-2x.jpg',
    },
    {
        src: 'b5101d497d622d421154e932ceaa7927-1751867297264/ProSeller-3-v2560-cropped-2x.jpg',
        alt: 'Pro Section Item 3',
        domain: 'Social media marketing',
        domainDesktop: 'Marketing strategist',
        ctaUrl: PRO_SECTION_TEXT_AND_CTA_URLS[2].ctaUrl,
        name: 'Andrew Pack',
        avatarSrc:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/778bcdb703d1be930088d803f5422479-1751956158382/avatar-pro-seller-3-2x.jpg',
    },
    {
        src: 'b5101d497d622d421154e932ceaa7927-1751867297265/ProSeller-4-v2560-cropped-2x.jpg',
        alt: 'Pro Section Item 4',
        domain: 'SEO',
        domainDesktop: 'SEO specialist',
        ctaUrl: PRO_SECTION_TEXT_AND_CTA_URLS[3].ctaUrl,
        name: 'Lora Harrison',
        avatarSrc:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/778bcdb703d1be930088d803f5422479-1751956158369/avatar-pro-seller-4-2x.jpg',
    },
    {
        src: 'b5101d497d622d421154e932ceaa7927-1751867297266/ProSeller-5-v2560-cropped-2x.jpg',
        alt: 'Pro Section Item 5',
        domain: 'Architecture & interior design',
        domainDesktop: 'Architect',
        ctaUrl: PRO_SECTION_TEXT_AND_CTA_URLS[4].ctaUrl,
        name: 'Rihanna Hill',
        avatarSrc:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/778bcdb703d1be930088d803f5422479-1751956158361/avatar-pro-seller-5-2x.jpg',
    },
];

export const PRO_SECTION_CAROUSEL_GAPS = {
    [theme.breakpoints.lg]: 14,
    [theme.breakpoints.xl]: 20,
    [brandPageTheme.breakpoints.xxl]: 28,
    [brandPageTheme.breakpoints.xxxl]: 36,
};
